/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_VaultInputs */

const en_label_vault = /** @type {(inputs: Label_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault`)
};

const id_label_vault = /** @type {(inputs: Label_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault`)
};

/** @type {(inputs: Label_VaultInputs) => LocalizedString} */
const es_label_vault = en_label_vault;

/** @type {(inputs: Label_VaultInputs) => LocalizedString} */
const fr_label_vault = en_label_vault;

/** @type {(inputs: Label_VaultInputs) => LocalizedString} */
const de_label_vault = en_label_vault;

/** @type {(inputs: Label_VaultInputs) => LocalizedString} */
const ja_label_vault = en_label_vault;

/** @type {(inputs: Label_VaultInputs) => LocalizedString} */
const zh_label_vault = en_label_vault;

/** @type {(inputs: Label_VaultInputs) => LocalizedString} */
const ar_label_vault = en_label_vault;

/** @type {(inputs: Label_VaultInputs) => LocalizedString} */
const it_label_vault = en_label_vault;

/** @type {(inputs: Label_VaultInputs) => LocalizedString} */
const ru_label_vault = en_label_vault;

/** @type {(inputs: Label_VaultInputs) => LocalizedString} */
const pt_label_vault = en_label_vault;

/** @type {(inputs: Label_VaultInputs) => LocalizedString} */
const ko_label_vault = en_label_vault;

/**
* | output |
* | --- |
* | "Vault" |
*
* @param {Label_VaultInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_vault = /** @type {((inputs?: Label_VaultInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_VaultInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_vault(inputs)
	if (locale === "es") return es_label_vault(inputs)
	if (locale === "fr") return fr_label_vault(inputs)
	if (locale === "de") return de_label_vault(inputs)
	if (locale === "ja") return ja_label_vault(inputs)
	if (locale === "zh") return zh_label_vault(inputs)
	if (locale === "ar") return ar_label_vault(inputs)
	if (locale === "id") return id_label_vault(inputs)
	if (locale === "it") return it_label_vault(inputs)
	if (locale === "ru") return ru_label_vault(inputs)
	if (locale === "pt") return pt_label_vault(inputs)
	return ko_label_vault(inputs)
});